import * as deviceAppsService from '../../../../services/Rfid/deviceAppsService.js';
import {createDialogActions} from '../../../Dialogs/CommonDialog/commonDialogActions';

export const {
  actionTypes,
  actions,
  api,
  jsxActions,
} = createDialogActions({

  config: {
    getSubmitMethod: ({isEditMode}) =>
      isEditMode  ? deviceAppsService.editDeviceApp : deviceAppsService.createDeviceApp,
  },
});
